import React from 'react';
import { default as withRouter } from "../../components/WithRouter/withRouter";

import Registration, { RegistrationTypes } from '../Registration/Registration';
import Success from '../Success/Success';
import CalculatorLayout from '../../components/CalculatorLayout/CalculatorLayout';
import { triggerConversionEvent } from '../../utils/paymentHelpers';

class ImSomethingElse extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: "register"
    };
  }

  onSuccess = () => {
    this.setState({ mode: "success" }, () => {
      triggerConversionEvent('other');
    });
  }

  render() {
    return (
      <CalculatorLayout title="'m hosting an event" highlightChar="i" hideTitle={this.state.mode === 'success'}>
        {this.state.mode !== 'success' &&
          <>
            <Registration type={RegistrationTypes.other} image={'/assets/reciprocity-event-logo.png'} submitText="Get in touch"
              buttonColor="#EB638D"
              subText={
                <>
                  <p>
                    Reciprocity payments offer a simple, accessible way for homes, businesses, and
                    events to act on the Indigenous principles that shaped and were shaped by the lands and
                    waters we love and rely on. They are voluntary, ongoing contributions that move beyond
                    symbolic acknowledgment toward meaningful action and meaningful relationships.
                  </p>
                  <p>
                    As a performer, event organizer or venue, you have uniquely wide reach. Tell us a bit about what you're up to and we'll work with you to make a Reciprocity plan for your event.
                  </p>
                </>
              }
              onSuccess={this.onSuccess}
            />
          </>
        }
        {this.state.mode === 'success' &&
          <Success type='other'></Success>
        }
      </CalculatorLayout>
    )
  }
}

export default withRouter(ImSomethingElse);
